import { toNumber } from '../deep/analyticsHelpers';

// One accent per metric (the same green / red the other analytics tabs use for revenue / costs),
// a neutral gray for the comparison series and recessive chart chrome.
export const COLORS = {
  intake: '#2a78d6',
  revenue: '#2e7d32',
  costs: '#b22222',
  margin: '#1e7d22',
  marginNegative: '#b22222',
  orderbook: '#6f4bd8',
  cash: '#2E5AAC',
  overdue: '#b7791f',
  previous: '#cfcdc6',
  grid: '#ebebe7',
  axis: '#8a8984',
  ink: '#303030',
  surface: '#ffffff'
};

export const AXIS_TICK = { fontSize: 11, fill: COLORS.axis };

const eur0 = new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const oneDecimal = new Intl.NumberFormat('nl-BE', { maximumFractionDigits: 1 });

export const formatEur = (value) => eur0.format(toNumber(value));

// short currency for axis ticks and dense labels: €250k, €1,2M
export function formatAxisCurrency(value) {
  const number = toNumber(value);
  const abs = Math.abs(number);
  if (abs >= 1e6) return `€${oneDecimal.format(number / 1e6)}M`;
  if (abs >= 1e3) return `€${Math.round(number / 1e3)}k`;
  return `€${Math.round(number)}`;
}

export const ratioFormatter = new Intl.NumberFormat('nl-BE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
